import {createSlice} from "@reduxjs/toolkit";

const initialInvoiceOrdersState = {
  listLoading: false,
  totalCount: 0,
  pageCount: 0,
  entities: null,
  error: null,
};
export const callTypesConfirmCustomers = {
  list: "list",
  action: "action"
};

export const invoiceOrdersConfirmCustomersSlice = createSlice({
  name: "invoiceOrdersConfirmCustomers",
  initialState: initialInvoiceOrdersState,
  reducers: {
    invoiceOrdersFetched: (state, action) => {
      const {totalCount, pageCount, entities} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.pageCount = pageCount;
    },
    invoiceOrdersAppended: (state, action) => {
      const {totalCount, pageCount, entities} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = state.entities ? [...state.entities, ...entities] : [...entities];
      state.totalCount = totalCount;
      state.pageCount = pageCount;
    },
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypesConfirmCustomers.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.invoiceOrdersError = null;
      if (action.payload.callType === callTypesConfirmCustomers.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
  }
});
